import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { BarberAvatar } from './barber-avatar';
export var BarberAvatarContainer = function (_a) {
    var id = _a.id, photoUrl = _a.photoUrl, firstName = _a.firstName, lastName = _a.lastName, _b = _a.size, size = _b === void 0 ? 'default' : _b;
    var _c = useState(false), imageLoaded = _c[0], setImageLoaded = _c[1];
    useEffect(function () {
        if (!photoUrl) {
            setImageLoaded(true);
            return;
        }
        var testImg = new Image();
        testImg.onload = function () { return setImageLoaded(true); };
        testImg.src = photoUrl;
    }, [photoUrl]);
    var showInitials = !photoUrl || !imageLoaded;
    return (_jsx(BarberAvatar, { id: id, firstName: firstName, lastName: lastName, photoUrl: photoUrl, showInitials: showInitials, size: size }));
};
